import { Directive, OnInit, inject, input } from '@angular/core';

import { DatabaseNotificationType } from '@shared/services/notifications';
import { PrimaryNotificationComponent } from './primary-notification/primary-notification.component';
import { DashboardNotification } from './dashboard-notification';

@Directive({
  selector: '[appAssignedPatientNotification]',
})
export class AssignedPatientNotificationDirective implements OnInit {
  private primaryNotificationComponent = inject(PrimaryNotificationComponent, { host: true });

  readonly notificationData = input.required<DatabaseNotificationType>();

  ngOnInit() {
    const { patientId, fromTherapistFirstName, fromTherapistLastName } = this.notificationData().data;

    const therapistName = `${fromTherapistFirstName} ${fromTherapistLastName}`;
    const timestamp = this.notificationData().ts;
    const readAtTime = this.notificationData().read;
    const id = this.notificationData().id;

    const icon = 'folder_shared';
    const link = `/therapist/assigned-patients/patient-profile/${patientId}`;
    const title = 'Patient Record Shared';
    const message = `A patient record has been shared with you by ${therapistName}.`;

    this.primaryNotificationComponent.notification.set(
      new DashboardNotification(icon, link, title, message, timestamp, readAtTime, id)
    );
  }
}
